import CardTable from 'components/CardTable/CardTable'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { columns } from './columns'

const fixFormat = Intl.NumberFormat('es-MX', { 
  style: 'currency', 
  currency: 'MXN', 
  minimumFractionDigits: 2
})

export const PrePayrollVariants = (props) => {
  const { prePayroll } = props
  const { isLoading } = useSelector((state) => state.search);

  const { allColumns, prePayrollMap } = useMemo(() => {
    const newColumnsMap = {}

    const parsed = prePayroll.map(employee => {
      const details = JSON.parse(employee.details)
      Object.keys(details).forEach(key => {
        if (!newColumnsMap[key]) newColumnsMap[key] = 0
      })
      return { employee, details }
    })

    const mappedData = parsed.map(({ employee, details }) => ({
      name: employee.name,
      id: employee.id,
      totalCommission: employee.totalCommission,
      ...newColumnsMap,
      ...details
    }))

    const dynamicColumns = Object.keys(newColumnsMap).map(column => ({
      Header: column,
      accessor: column,
      filterable: true,
      width: 400,
      Cell: props => props.value != null ? fixFormat.format(props.value) : null,
      filterMethod: (filter, row) => row[column]?.toString().toLowerCase().includes(filter.value.toLowerCase())
    }))

    return {
      allColumns: [...columns, ...dynamicColumns],
      prePayrollMap: mappedData
    }
  }, [prePayroll])

  return (
    <CardTable
      data={prePayrollMap}
      columns={allColumns}
      loading={isLoading}
      blockBtn
    />
  )
}
